<template>
  <div>
    <vx-card style="margin-bottom: 15px">
      <b-row align-v="center">
        <b-col lg="2" sm="5">
          <b-form-input
            v-model="arananDeger"
            @keyup.enter="getMutbakatRaporList"
            id="smallInput"
            placeholder="Cari No/Adı"
          />
        </b-col>
        <b-col lg="2" sm="5">
          <v-select
            v-model="secilenDonem"
            :options="donemList"
            class="select-size-sm"
            label="YILAY"
            placeholder="Dönem"
            style=""
          >
          </v-select>
        </b-col>
        <b-col lg="2" sm="5">
          <v-select
            v-model="secilenDurum"
            :options="durumList"
            placeholder="Durum"
            style=""
          >
          </v-select>
        </b-col>
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="listele()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Listele</vs-button
          >
        </b-col>
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px"
            type="gradient"
            size=""
            @click="tekrarGonder()"
            color="danger"
            id="button-with-loading-tekrar"
            class="vs-con-loading__container"
            >{{ tekrartitle }}</vs-button
          >
        </b-col>
        <b-col lg="2" sm="2">
          <vs-button
            style="border-radius: 5px; width: 100%"
            type="gradient"
            size=""
            @click="guncelCariMutabakat()"
            id="button-with-loading-yeni"
            class="vs-con-loading__container"
            >Güncel Cari Mutabakat</vs-button
          >
        </b-col>
      </b-row>
    </vx-card>
    <vx-card>
      <b-row style="margin-bottom: 10px">
        <b-col cols="2">
          <ButtonPrimary
            :color="filtrecolor"
            :size="size"
            :title="title"
            @test-click="resetState"
          />
        </b-col>
        <b-col cols="6"></b-col>
        <b-col cols="4" style="padding: 0; padding-right: 20px">
          <b-row align-h="end">
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="primary"> Görüldü </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="success"> Onaylandı </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="danger"> Red Edildi </vs-chip>
            </b-col>
            <b-col cols="12" md="auto" style="padding: 0"
              ><vs-chip transparent color="warning"> Mail Gönderildi </vs-chip>
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <ag-grid-vue
        style="width: 100%; height: 500px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :localeText="localeText"
        :pagination="true"
        @selection-changed="onSelectionChanged"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowClassRules="rowClassRules"
        :isRowSelectable="isRowSelectable"
        :rowSelection="rowSelection"
        @filter-changed="onFilterChanged"
        :suppressRowClickSelection="true"
        @filter-modified="onFilterModified"
      >
      </ag-grid-vue>
    </vx-card>
    <GuncelMutabakatPopup
      :isSidebarActive="isSidebarActiveGm"
      :data="selectedDataFor"
      @closeSidebar="toggleDataSidebar"
    />
  </div>
</template>
<script>
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import TahsilatRaporDetay from "../components/crm-components/finans-components/TahsilatRaporDetay.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import vSelect from "vue-select";
import { BBadge } from "bootstrap-vue";
import GuncelMutabakatPopup from "./CellRenderers/GuncelMutabakatPopup.vue";
import guncelMutabakatCellRenderer from "./CellRenderers/guncelMutabakatCellRenderer.vue";
export default {
  data() {
    return {
      selectedDataFor: "",
      selectedData: [],
      isSidebarActiveGm: false,
      tekrarcolor: "danger",
      tekrartitle: "Tekrar Gönder",
      listsize: "",
      listtitle: "Listele",
      size: "small",
      title: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      isRowSelectable: null,
      rowClassRules: null,
      durumList: [
        "Tümü",
        "Hazır",
        "Mail Gönderildi",
        "Görüldü",
        "Onaylandı",
        "Red Edildi",
        "Hata",
      ],
      secilenDurum: "",
      frameworkComponents: null,
      localeText: null,
      columnDefs: null,
      rowData: null,
      datepickerbaslangic: "",
      datepickerbitis: "",
      columnApi: null,
      arananDeger: "",
      dir: false,
      searchTerm: "",
      pageLength: 10,
      rows: [],
      columns: null,
      rowSelection: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      donemList: [],
      secilenDonem: "",
      secilenRaporlar: [],
      gelenfiltre: "",
    };
  },
  components: {
    guncelMutabakatCellRenderer,
    GuncelMutabakatPopup,
    ButtonPrimary,
    AgGridVue,
    TahsilatRaporDetay,
    "v-select": vSelect,
    BBadge,
  },
  beforeMount() {
    this.columnDefs = [
      {
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        headerName: "Cari No",
        field: "ACTID",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Dönem",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "YILAY",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Mail",
        field: "EMAIL",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "İşlem Tarihi",
        field: "ISLEMTARIHI",
        sortable: true,
        filter: "agTextColumnFilter",

        valueFormatter: this.parseDate,
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Borç",
        field: "BORC",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BORC, "₺"),
      },
      {
        headerName: "Alacak",
        field: "ALACAK",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.ALACAK, "₺"),
      },
      {
        headerName: "Bakiye",
        field: "BAKIYE",
        sortable: true,
        filter: "agNumberColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
        type: "rightAligned",
        valueFormatter: (params) => this.currencyFormatter(params.data.BAKIYE, "₺"),
      },
      {
        headerName: "Gönderi Key",
        field: "GONDKEY",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Durum",
        field: "DURUM",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Red Sebep",
        field: "REDSEBEP",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"] },
      },
      {
        headerName: "Güncel Mutabakat Durumu",
        cellRenderer: "guncelMutabakatCellRenderer",
      },
    ];
  },
  created() {
    this.rowSelection = "multiple";
    this.rowClassRules = {
      "green-row": 'data.DURUM == "Onaylandı"',
      "blue-row": 'data.DURUM == "Görüldü"',
      "yellow-row": 'data.DURUM == "Mail Gönderildi"',
      "red-row": 'data.DURUM == "Red Edildi"',
    };
    this.isRowSelectable = (node) => {
      return node.data
        ? node.data.DURUM === "Görüldü" ||
            node.data.DURUM === "Mail Gönderildi" ||
            node.data.DURUM === "HAZIR" ||
            node.data.DURUM === "Hata" ||
            node.data.DURUM === "Red Edildi"
        : false;
    };

    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.getMutbakatDonemList();
  },
  methods: {
    guncelMutabakatList(item) {
      this.isSidebarActiveGm = true;
    },
    toggleDataSidebar(val = false) {
      try {
        this.isSidebarActiveGm = val;
      } catch (error) {
        console.log(error);
      }
    },

    guncelCariMutabakat() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.selectedData = selectedRows;

      this.guncelMutabakatSave(this.selectedData.length - 1);
    },
    guncelMutabakatSave(index) { 
      const vs = this.$vs;
      var vm = this;

      if (index == -1) {
        vm.getMutbakatRaporList();
      } else {
        const soap = require("soap");
        const url = state.sistemAddress;
        const args = {
          token: Store.state.tokenId,
          ACTID: vm.selectedData[index].ACTID,
          YILAY: vm.secilenDonem.YILAY,
        }; 
        if (vm.secilenDonem.YILAY != "" && typeof vm.secilenDonem.YILAY != "undefined") {
          soap.createClient(url, function (err, client) {
            client.INT_GUNCEL_MUTABAKAT_KAYDET(args, function (err, result) {
              
              if (result.INT_GUNCEL_MUTABAKAT_KAYDETResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              try {
                vm.veriler = JSON.parse(result.INT_GUNCEL_MUTABAKAT_KAYDETResult);
                if (vm.veriler.response == "Ok") { 
                  let receiver = vm.selectedData[index].EMAIL;
                  let args2 = {
                    ALICI: receiver,
                    MESAJ:
                      " <table> <tr> <td style='padding-right: 75px;'> <img src='https://int.kamyonyedekparca.com/uploads/logo.png' style='height: 150px' alt='login' class='mx-auto' /> </td>" +
                      " <td>  <h3>	  DENİZLİ CANER OTOMOTİV SAN. TİC. A.Ş. <br><br>  Cari Mutabakat Sistemi </h3>" +
                      " </td>  </tr>  </table> " +
                      "<br /> <br />Sayın " +
                      vm.selectedData[index].ACTNAME +
                      "<br /><h3>Bu email Caner Group Crm sistemi tarafından Cari Mutabakat sağlamak için otomatik olarak gönderilmiştir. Lütfen Aşağıdaki linke tıklayarak Cari Mutabakatınızı sağlayınız. </h3>" +
                      "<br /><a href='https://servis.kamyonyedekparca.com/c2/mutabakatonayla.aspx?Root=Mutabakat&Key=" +
                      vm.veriler.jsonData +
                      "'>" +
                      "Lutfen islem yapmak icin tiklayiniz" +
                      " </a>" +
                      "<br /><p>Bu e-posta mesajı ve ekleri gönderildiği kişi ya da kuruma özeldir ve gizlidir. Ayrıca hukuken de gizli olabilir. Hiçbir şekilde üçüncü kişilere açıklanamaz ve yayınlanamaz. Mesajın yetkili alıcısı değilseniz hiçbir kısmını kopyalayamaz, başkasına gönderemez veya hiçbir şekilde kullanamazsınız. Eğer mesajın yetkili alıcısı veya yetkili alıcısına iletmekten sorumlu kişi siz değilseniz, lütfen mesajı sisteminizden siliniz ve göndereni uyarınız. Bu e-posta esasen bilgilendirmeye yönelik olduğu için firma tarafından yazılı olarak onaylanmadıkça YENİKÖY KEMERKÖY ELEKTRİK ÜRETİM VE TİCARET A.Ş. içerik hakkında hiçbir mesuliyet kabul etmez. Ayrıca mesajın içeriğinden, doğruluğundan, bütünlüğünden, güncelliğinden, iletilmesinden, alınmasından, saklanmasından, gizliliğinin korunamamasından, virüs içermesinden ve sisteminizde yaratabileceği zararlardan ve şahsi amaçlarla gönderilmiş mesajlardan firmamız sorumlu tutulamaz. </p>" +
                      "<br /><p>This e-mail and its attachments are private and confidential to the exclusive use of the individual or entity to whom it is addressed. It may also be legally confidential. Any disclosure, distribution or other dissemination of this message to any third party is strictly prohibited. If you are not the intended recipient, you may not copy, forward, send or use any part of it. If you are not the intended recipient or the person who is responsible to transmit to the intended recipient, please contact the sender by reply e-mail and destroy all copies of the original message and its attachments. As this email is primarily for the provision of information,YENİKÖY KEMERKÖY ELEKTRİK ÜRETİM VE TİCARET A.Ş. accepts no liability for its content, unless that content is subsequently confirmed by the company in writing. Our company shall also have no liability with regard to the information contained in the message, its accuracy, integrity, currency, transmission, reception, storage, preservation of confidentiality, viruses or any damages caused in any way to your computer system and the messages send by personal purposes. </p>",
                    KONU: "Caner Group- Cari Mutabakat",
                  }; 
                  soap.createClient(url, function (err, client) {
                    client.mailGonder(args2, function (err, result) {
                      if (result.mailGonderResult == "-1") {
                        //  Store.dispatch("logout");
                        //vm.$store.dispatch('login', payload)
                      }
                      let veriler2 = JSON.parse(result.mailGonderResult);
                      try { 
                        if (veriler2.response == "Ok") {
                          vs.notify({
                            title: "Mail",
                            text: "Mail başarıyla gönderildi." + veriler2.message,
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "success",
                            position: "top-center",
                          });
                          index--;
                          vm.guncelMutabakatSave(index);
                        }
                      } catch (error) {
                        console.log(error);
                        vs.notify({
                          title: "Mail",
                          text: "Mail göndermede hata oluştu." + veriler2.message,
                          iconPack: "feather",
                          icon: "icon-alert-circle",
                          color: "danger",
                          position: "top-center",
                        });
                      }
                    });
                  });
                } else {
                }
              } catch (error) {}

              //  vm.cariHareketlerListesi = vm.veriler;
            });
          });
        } else {
          const vs = this.$vs;
          vs.notify({
            title: "Mutabakat Raporu",
            text: "Dönem değeri giriniz.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      }
    },
    currencyFormatter(currency, sign) {
      if (currency == "") {
        return "";
      } else {
        var sansDec = currency.toFixed(2);
        var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return sign + `${formatted}`;
      }
    },
    resetState() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.getMutbakatRaporList();
    },
    onFilterChanged(e) {
      var savedFilterModel = e.api.getFilterModel();
      var keys = Object.keys(savedFilterModel);

      if (keys.length > 1) {
        console.log("arama yapma");
      } else {
        var vm = this;
        const soap = require("soap");
        const url = state.sistemAddress;
        if (vm.gelenfiltre == "") {
          vm.getMutbakatRaporList();
        } else {
          const args = {
            token: Store.state.tokenId,
            ARANAN: vm.gelenfiltre,
            DURUM: vm.secilenDurum,
            DONEM: vm.secilenDonem.YILAY,
          };
          if (
            vm.secilenDonem.YILAY != "" &&
            typeof vm.secilenDonem.YILAY != "undefined"
          ) {
            soap.createClient(url, function (err, client) {
              client.INT_MUTABAKAT_RAPORU(args, function (err, result) {
                if (result.INT_MUTABAKAT_RAPORUResult == "-1") {
                  Store.dispatch("logout");
                  //this.$store.dispatch('login', payload)
                }
                try {
                  vm.veriler = JSON.parse(result.INT_MUTABAKAT_RAPORUResult);
                  if (vm.veriler.response == "Ok") {
                    var list = JSON.parse(vm.veriler.jsonData);
                    vm.rowData = list;
                  } else {
                  }
                } catch (error) {}

                //  vm.cariHareketlerListesi = vm.veriler;
              });
            });
          } else {
            const vs = this.$vs;
            vs.notify({
              title: "Mutabakat Raporu",
              text: "Dönem değeri giriniz.",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "warning",
              position: "top-center",
            });
          }
        }
      }
    },
    onFilterModified(e) {
      if (e.filterInstance.getModelFromUi() == null) {
        this.gelenfiltre = "";
      } else this.gelenfiltre = e.filterInstance.getModelFromUi().filter;
    },

    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    tekrarGonder() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#640064",
        color: "#fff",
        container: "#button-with-loading-tekrar",
        scale: 0.45,
      });
      const soap = require("soap");
      const url = state.sistemAddress;
      vm.secilenRaporlar.forEach((val, index) => {
        const args = {
          token: Store.state.tokenId,
          ACTID: val.ACTID,
          DONEM: val.YILAY,
        };
        soap.createClient(url, function (err, client) {
          client.INT_MUTABAKAT_TEKRARLA(args, function (err, result) {
            if (result.INT_MUTABAKAT_TEKRARLAResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_MUTABAKAT_TEKRARLAResult);
              if (vm.veriler.response == "Ok") {
                vs.loading.close("#button-with-loading-tekrar > .con-vs-loading");
                vm.getMutbakatRaporList();
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Tekrar gönderilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      });
    },
    listele() {
      this.getMutbakatRaporList();
    },
    onSelectionChanged(params) {
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenRaporlar = selectedRows;
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.getMutbakatRaporList();
    },
    getNow() {
      const today = new Date();
      const date =
        today.getDate() + "." + (today.getMonth() + 1) + "." + today.getFullYear();

      const dateTime = date;
      return dateTime;
    },
    getLastTreeMonth() {
      var d = new Date();
      d.setMonth(d.getMonth() - 3);
      return d.toLocaleDateString();
    },
    getMutbakatDonemList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.INT_MUTABAKAT_DONEM(args, function (err, result) {
          if (result.INT_MUTABAKAT_DONEMResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            vm.veriler = JSON.parse(result.INT_MUTABAKAT_DONEMResult);
            vm.donemList = vm.veriler;
            //  vm.rowData = vm.veriler;
            //  vm.cariHareketlerListesi = vm.veriler;
          } catch (error) {}
        });
      });
    },
    getMutbakatRaporList(aranan) {
      var vm = this;

      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        ARANAN: vm.arananDeger,
        DURUM: vm.secilenDurum,
        DONEM: vm.secilenDonem.YILAY,
      };
      if (vm.secilenDonem.YILAY != "" && typeof vm.secilenDonem.YILAY != "undefined") {
        soap.createClient(url, function (err, client) {
          client.INT_MUTABAKAT_RAPORU(args, function (err, result) {
            if (result.INT_MUTABAKAT_RAPORUResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_MUTABAKAT_RAPORUResult);
              if (vm.veriler.response == "Ok") {
                var list = JSON.parse(vm.veriler.jsonData);
                vm.rowData = list;
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      } else {
        vs.notify({
          title: "Mutabakat Raporu",
          text: "Dönem değeri giriniz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "top-center",
        });
        vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
      }
    },
    direction() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  mounted() {
    this.$root.$on("guncelMutabakatList", (stokDetayVal) => { 
      this.selectedDataFor = stokDetayVal.data;
      this.guncelMutabakatList(stokDetayVal.data);
    });
  },
  beforeDestroy() {
    this.$root.$off("guncelMutabakatList");
  },
};
</script>

<style lang="scss">
@import "~ag-grid-community/dist/styles/ag-grid.css";
@import "~ag-grid-community/dist/styles/ag-theme-alpine.css";

.ag-theme-alpine .ag-row {
  font-size: 13px;
  height: 35px;
}
.green-row {
  background-color: #48da89 !important;
}
.yellow-row {
  background-color: #ffb976 !important;
}

.red-row {
  background-color: #f08182 !important ;
}

.blue-row {
  background-color: #9e95f5 !important;
}
.sick-days-warning {
  background-color: sandybrown !important;
}
</style>
